import NextImage from "next/image";

/**
 *
 * @param {object} props -
 */
export default function CustomImage(props) {
  return <NextImage {...props} quality={props.quality ?? 75} />;
}
